export default __webpack_public_path__ + "static/media/icon.3bfb5802.svg";